import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Home from './components/Home/Home';
import Services from './components/Services/Services';
import Blog from './components/Blog/Blog';
import BlogDetail from './components/Blog/BlogDetail';
import Contact from './components/Contact/Contact';
import AccueilAssociation from './components/association/AccueilAssociation/AccueilAssociation';

import EtudiantEtrangerHorsFrance from './components/EtudiantEtrangerHorsFrance';
import EtudiantEtrangerEnFrance from './components/EtudiantEtrangerEnFrance';
import EcoleUnivAfricaine from './components/EcoleUnivAfricaine';
import EcoleUnivFrancaise from './components/EcoleUnivFrancaise';

import QuiSommesNous from './components/QuiSommesNous/QuiSommesNous';
import EquipeETEF from './components/EquipeETEF/EquipeETEF';
import UniversitesPartenaires from './components/UniversitesPartenaires/UniversitesPartenaires';

// Import des composants admin
import AdminDashboard from './components/administrateur/dashboard/AdminDashboard';
import BlogList from './components/administrateur/blogs/BlogList';
import BlogForm from './components/administrateur/blogs/BlogForm';

import Connexion from './components/auth/Connexion';
import Inscription from './components/auth/Inscription';

import EventList from './components/administrateur/evenements/EventList';
import EventListPublic from './components/evenement/EventListPublic';
import EventDetail from './components/evenement/EventDetail';
import ContactListe from './components/administrateur/contacts/ContactListe';

import WhatsAppButton from './components/WhatsAppButton';
import Representants from './components/representants/Representants';
import Paiements from './components/paiements/Paiements';
import AllService from './components/allservices/AllServices';


import AccompagnementVisa from './components/service-accompagnement-visa/AccompagnementVisa';
import AdmissionUniversitaire from './components/service-admission-universitaire/AdmissionUniversitaire';
import HebergementEtudiant from './components/service-hebergement-etudiant/HebergementEtudiant';
import IntegrationSociale from './components/service-integration-sociale/IntegrationSociale';
import PartenariatsEntreprises from './components/service-partenariats-entreprises/PartenariatsEntreprises';
import SupportContinu from './components/service-support-continu/SupportContinu';

// import NosServices from './components/association/NosServices';
import RenouvellementTitreSejour from './components/association/services/RenouvellementTitreSejour';
import VoyageTourisme from './components/association/services/VoyageTourisme';
import DemarchesAdministratives from './components/association/services/DemarchesAdministratives';
import MarcheTravail from './components/association/services/MarcheTravail';
import Entrepreneuriat from './components/association/services/Entrepreneuriat';
import AideFinanciere from './components/association/services/AideFinanciere';
import ConseilOrientation from './components/association/services/ConseilOrientation';
import SanteMentale from './components/association/services/SanteMentale';
import SystemeEducatif from './components/association/services/SystemeEducatif';
import DroitsJuridiques from './components/association/services/DroitsJuridiques';
import EvenementsCulturels from './components/association/services/EvenementsCulturels';
import IntegrationCulturelle from './components/association/services/IntegrationCulturelle';
import RechercheLogement from './components/association/services/RechercheLogement';
import OpportunitesFinancement from './components/association/services/OpportunitesFinancement';
import VieApresEtudes from './components/association/services/VieApresEtudes';
import ImmigrationConsulaire from './components/association/services/ImmigrationConsulaire';

import PaiementsCoteIvoire from './components/paiements/PaiementsCoteIvoire';
// Composant ProtectedRoute pour protéger les routes
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  
  if (!token) {
    // Rediriger vers la page de connexion si non authentifié
    return <Navigate to="/connexion" replace />;
  }
  
  return children;
};

// Composant AdminRoute pour vérifier les privilèges admin (optionnel)
const AdminRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  
  if (!token) {
    return <Navigate to="/connexion" replace />;
  }
  
  // Si vous avez un champ is_admin dans votre user
  if (!user.is_admin) {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

function App() {
  return (
    <Router>

      <WhatsAppButton />
      <div className="App">
        <Routes>
          {/* Routes publiques */}
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/association" element={<AccueilAssociation />} />
          
          <Route path="/etudiant-etranger-hors-france" element={<EtudiantEtrangerHorsFrance />} />
          <Route path="/etudiant-etranger-en-france" element={<EtudiantEtrangerEnFrance />} />
          <Route path="/ecole-universite-africaine" element={<EcoleUnivAfricaine />} />
          <Route path="/ecole-universite-francaise" element={<EcoleUnivFrancaise />} />

          <Route path="/qui-sommes-nous" element={<QuiSommesNous />} />
          <Route path="/equipe-etef" element={<EquipeETEF />} />
          <Route path="/universites-partenaires" element={<UniversitesPartenaires />} />

          {/* Routes d'authentification */}
          <Route path="/connexion" element={<Connexion />} />
          <Route path="/inscription" element={<Inscription />} />

          {/* Routes admin protégées */}
          <Route path="/admin" element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } />
          
          <Route path="/admin/blogs" element={
            <ProtectedRoute>
              <BlogList />
            </ProtectedRoute>
          } />
          
          <Route path="/admin/blogs/nouveau" element={
            <ProtectedRoute>
              <BlogForm />
            </ProtectedRoute>
          } />
          
          <Route path="/admin/blogs/:id/modifier" element={
            <ProtectedRoute>
              <BlogForm />
            </ProtectedRoute>
          } />

          <Route path="/admin/evenements" element={
            <ProtectedRoute>
              <EventList />
            </ProtectedRoute>
          } />

          {/* Redirection pour les routes non trouvées */}
          {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
          <Route path="/evenements" element={<EventListPublic />} />
          <Route path="/events/:slug" element={<EventDetail />} />

          <Route path="/admin/contacts" element={<ContactListe />} />
          <Route path="/representants" element={<Representants />} />

          <Route path="/paiements" element={<Paiements />} />
          <Route path="/servicesall" element={<AllService />} />

          <Route path="/service/accompagnement-visa" element={<AccompagnementVisa />} />
          <Route path="/service/admission-universitaire" element={<AdmissionUniversitaire />} />
          <Route path="/service/hebergement-etudiant" element={<HebergementEtudiant />} />
          <Route path="/service/integration-sociale" element={<IntegrationSociale />} />
          <Route path="/service/partenariats-entreprises" element={<PartenariatsEntreprises />} />
          <Route path="/service/support-continu" element={<SupportContinu />} />

                    {/* <Route path="/nos-services" element={<NosServices />} /> */}
          <Route path="/services/renouvellement-titre-sejour" element={<RenouvellementTitreSejour />} />
          <Route path="/services/voyage-tourisme" element={<VoyageTourisme />} />
          <Route path="/services/demarches-administratives" element={<DemarchesAdministratives />} />
          <Route path="/services/marche-travail" element={<MarcheTravail />} />
          <Route path="/services/entrepreneuriat" element={<Entrepreneuriat />} />
          <Route path="/services/aide-financiere" element={<AideFinanciere />} />
          <Route path="/services/conseil-orientation" element={<ConseilOrientation />} />
          <Route path="/services/sante-mentale" element={<SanteMentale />} />
          <Route path="/services/systeme-educatif" element={<SystemeEducatif />} />
          <Route path="/services/droits-juridiques" element={<DroitsJuridiques />} />
          <Route path="/services/evenements-culturels" element={<EvenementsCulturels />} />
          <Route path="/services/integration-culturelle" element={<IntegrationCulturelle />} />
          <Route path="/services/recherche-logement" element={<RechercheLogement />} />
          <Route path="/services/opportunites-financement" element={<OpportunitesFinancement />} />
          <Route path="/services/vie-apres-etudes" element={<VieApresEtudes />} />
          <Route path="/services/immigration-consulaire" element={<ImmigrationConsulaire />} />

          <Route path="/paiements-cote-ivoire" element={<PaiementsCoteIvoire />} />

        </Routes>
      </div>
    </Router>
  );
}

export default App;